"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spacer = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = require("../../elements/Box");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A component used to inject space where it's needed
 */


var Spacer = function Spacer(props) {
  return /*#__PURE__*/_react.default.createElement(_Box.Box, props);
};

exports.Spacer = Spacer;
Spacer.displayName = "Spacer";
Spacer.displayName = "Spacer";